var _path, _path2, _path3, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrowserCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.33333V14.6667C3 15.7712 3.89543 16.6667 5 16.6667H8M3 8.33333V5.33333C3 4.22876 3.89543 3.33333 5 3.33333H16C17.1046 3.33333 18 4.22876 18 5.33333V8.33333M3 8.33333H18M18 8.33333V10.8333",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.3333L11.3334 15L13 16.6667",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 13.3333L18 15L16.3333 16.6667",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.49996,
    cy: 5.83333,
    r: 0.833333,
    fill: "currentColor",
    fillOpacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99996,
    cy: 5.83333,
    r: 0.833333,
    fill: "currentColor",
    fillOpacity: 0.7
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserCode);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zIDguMzMzMzNWMTQuNjY2N0MzIDE1Ljc3MTIgMy44OTU0MyAxNi42NjY3IDUgMTYuNjY2N0g4TTMgOC4zMzMzM1Y1LjMzMzMzQzMgNC4yMjg3NiAzLjg5NTQzIDMuMzMzMzMgNSAzLjMzMzMzSDE2QzE3LjEwNDYgMy4zMzMzMyAxOCA0LjIyODc2IDE4IDUuMzMzMzNWOC4zMzMzM00zIDguMzMzMzNIMThNMTggOC4zMzMzM1YxMC44MzMzIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW9wYWNpdHk9IjAuNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMyAxMy4zMzMzTDExLjMzMzQgMTVMMTMgMTYuNjY2NyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIwLjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTYuMzMzMyAxMy4zMzMzTDE4IDE1TDE2LjMzMzMgMTYuNjY2NyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIwLjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSI1LjQ5OTk2IiBjeT0iNS44MzMzMyIgcj0iMC44MzMzMzMiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPGNpcmNsZSBjeD0iNy45OTk5NiIgY3k9IjUuODMzMzMiIHI9IjAuODMzMzMzIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };